/* eslint-disable no-irregular-whitespace */
<template>
  <div class="p-menu">
    <div class="l-container">
      <div class="c-box mb-12 mt-px">
        <SubHeaderMenu :value="objSubHeader" :showMenuNm="true"/>
        <MenuNavigation />

        <div class="menu-main-content" v-for="(el, index) in dataService" :key="`equip-${index}`">
          <div v-for="(item, index) in el.equipServDetail1" :key="`service-${index}`">
            <section class="mt-8 mb-8">
              <SectionContentTitle
                :titleContent="item.equipServNm1"
              />

              <div class="cols-3" v-if="item.equipServDetail2.length % 3 === 0">
                <div v-for="(item1, index1) in item.equipServDetail2" :key="`detail-${index1}`">
                  <Label :title="item1.equipServNm2" :content="item1.equipServValue2 ? item1.equipServValue2 : 'null'" type_title="title-small" type_content="content-small"/>
                </div>
              </div>

              <div class="mt-2 cols-3" v-if="item.equipServDetail2.length % 3 === 1">
                <div v-for="(item1, index1) in item.equipServDetail2.slice(0,item.equipServDetail2.length -1)" :key="`detail-${index1}`">
                  <Label :title="item1.equipServNm2" :content="item1.equipServValue2 ? item1.equipServValue2 : 'null'" type_title="title-small" type_content="content-small"/>
                </div>
              </div>
              <div class="mt-2 cols-1" v-if="item.equipServDetail2.length % 3 === 1">
                <div v-for="(item1, index1) in item.equipServDetail2.slice(item.equipServDetail2.length -1, item.equipServDetail2.length)" :key="`detail-${index1}`">
                  <Label :title="item1.equipServNm2" :content="item1.equipServValue2 ? item1.equipServValue2 : 'null'" type_title="title-big" type_content="content-big" label_inp_mid="label_inp_mid"/>
                </div>
              </div>

              <div class="mt-2 cols-3" v-if="item.equipServDetail2.length % 3 === 2">
                <div v-for="(item1, index1) in item.equipServDetail2.slice(0, item.equipServDetail2.length-2)" :key="`detail-${index1}`">
                  <Label :title="item1.equipServNm2" :content="item1.equipServValue2 ? item1.equipServValue2 : 'null'" type_title="title-small" type_content="content-small"/>
                </div>
              </div>

              <div class="mt-2 cols-2" v-if="item.equipServDetail2.length % 3 === 2">
                <div v-for="(item1, index1) in item.equipServDetail2.slice(item.equipServDetail2.length -2, item.equipServDetail2.length)" :key="`detail-${index1}`">
                  <Label :title="item1.equipServNm2" :content="item1.equipServValue2 ? item1.equipServValue2 : 'null'" type_title="title-mid" type_content="content-mid" label_inp_mid="label_inp_mid"/>
                </div>
              </div>

            </section>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {
  SubHeaderMenu,
  MenuNavigation,
  SectionContentTitle
} from '@/components/compound'
import Label from './components/Input'
import { GET_SERVICE_DETAIL } from '@/store/modules/service/actions.js'


export default {
  components: {
    SubHeaderMenu,
    MenuNavigation,
    SectionContentTitle,
    Label
  },
  data() {
    return {
      latitude: null,
      longitude: null,
      dataService: {},
      objSubHeader: {},
      menuNm: null,
      breadcrumb_data: ['トップ', '旅・宿泊', '国内宿泊', '宿泊施設名宿泊施設名宿泊施設名'],
      open: false
    }
  },
  mounted() {
    if (this.loggedIn) {
      const { menuNo } = this.$route.query
      this.$store.dispatch(GET_SERVICE_DETAIL, menuNo).then(
        (data) => {
          if (data !== null) {
            this.dataService = [data[0]]
          }
        }
      )
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({path: '/', query: params})
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  methods: {
    
  }
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
